import { ErrorOutline } from "@mui/icons-material";

export function InformationOutline() {
  return <ErrorOutline sx={{ transform: "rotateX(180deg)" }} />;
}
